(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maverik-policy-content"]) return;
  try {
    
(() => {
  const applyPolicyPreview = () => {
    const page = document.querySelector('[data-maverik-policy]');
    if (!page) return;
    const refund = location.pathname.includes('/policies/refund-policy') || location.hash === '#maverik-refund-preview';
    page.querySelectorAll('[data-policy-content]').forEach(article => {
      article.hidden = article.dataset.policyContent !== (refund ? 'refund' : 'privacy');
    });
    const title = page.querySelector('[data-policy-title]');
    title.textContent = refund ? 'Grąžinimas ir pinigų grąžinimas' : 'Privatumo politika';
    document.title = title.textContent + ' – MAVERIK';
  };
  applyPolicyPreview();
  window.addEventListener('hashchange', () => { applyPolicyPreview(); window.scrollTo({top: 0, behavior: 'instant'}); });
  document.addEventListener('shopify:section:load', applyPolicyPreview);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zp-customer-reviews')) {
    customElements.define('zp-customer-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const list = this.querySelector('[data-cr-list]');
        const cards = Array.from(this.querySelectorAll('[data-cr-review]'));
        const filter = this.querySelector('[data-cr-filter]');
        const sort = this.querySelector('[data-cr-sort]');
        const search = this.querySelector('[data-cr-search]');
        const photos = this.querySelector('[data-cr-photos-filter]');
        const more = this.querySelector('[data-cr-more]');
        const pageSize = Math.max(1, Number(this.dataset.crPageSize) || 5);
        let visibleLimit = pageSize;
        const apply = () => {
          const query = search.value.trim().toLocaleLowerCase();
          const ordered = [...cards];
          if (sort.value === 'newest') ordered.sort((a,b) => Number(a.dataset.days) - Number(b.dataset.days));
          if (sort.value === 'oldest') ordered.sort((a,b) => Number(b.dataset.days) - Number(a.dataset.days));
          if (sort.value === 'highest') ordered.sort((a,b) => Number(b.dataset.rating) - Number(a.dataset.rating));
          if (sort.value === 'lowest') ordered.sort((a,b) => Number(a.dataset.rating) - Number(b.dataset.rating));
          if (sort.value === 'helpful') ordered.sort((a,b) => Number(b.querySelector('[data-cr-vote-count]')?.dataset.base || 0) - Number(a.querySelector('[data-cr-vote-count]')?.dataset.base || 0));
          let matches = 0;
          ordered.forEach(card => {
            const match = (filter.value === 'all' || card.dataset.rating === filter.value) && (!photos.checked || card.querySelector('.cr-photos')) && (!query || card.textContent.toLocaleLowerCase().includes(query));
            card.hidden = !match || matches >= visibleLimit;
            if (match) matches++;
            list.append(card);
          });
          this.querySelector('[data-cr-empty]').hidden = matches > 0;
          more.hidden = matches <= visibleLimit;
        };
        const reset = () => {visibleLimit = pageSize;apply();};
        filter.addEventListener('change', reset, {signal});
        sort.addEventListener('change', reset, {signal});
        search.addEventListener('input', reset, {signal});
        photos.addEventListener('change', reset, {signal});
        more.addEventListener('click', () => {visibleLimit += pageSize;apply();}, {signal});
        this.querySelectorAll('[data-cr-rating]').forEach(button => button.addEventListener('click', () => {filter.value = button.dataset.crRating;reset();}, {signal}));
        this.querySelectorAll('[data-cr-vote-count]').forEach(node => {node.dataset.base ??= node.textContent;node.hidden = Number(node.textContent) === 0;});
        this.querySelectorAll('[data-cr-vote]').forEach(button => button.addEventListener('click', () => {
          const card = button.closest('[data-cr-review]');
          const pressed = button.getAttribute('aria-pressed') === 'true';
          card.querySelectorAll('[data-cr-vote]').forEach(vote => {
            const active = vote === button && !pressed;
            vote.setAttribute('aria-pressed', String(active));
            const count = vote.querySelector('[data-cr-vote-count]');
            const value = Number(count.dataset.base) + Number(active);
            count.textContent = String(value);count.hidden = value === 0;
          });
          card.querySelector('[data-cr-vote-notice]').hidden = pressed;
        }, {signal}));
        const desktop = matchMedia('(min-width:750px)');
        const filterDetails = this.querySelector('.cr-filter');
        const updateFilter = () => {filterDetails.open = desktop.matches;};
        desktop.addEventListener('change', updateFilter, {signal});
        updateFilter();
        const dialog = this.querySelector('.cr-dialog');
        let photoTrigger;
        this.querySelectorAll('[data-cr-photo]').forEach(button => button.addEventListener('click', event => {
          if (this.galleryDragged && event.detail !== 0) return;
          photoTrigger = button;
          const image = button.querySelector('img');
          if (!image) return;
          const full = dialog.querySelector('[data-cr-dialog-image]');
          full.src = image.currentSrc || image.src;full.alt = image.alt;
          dialog.querySelector('[data-cr-dialog-title]').textContent = button.dataset.crTitle;
          dialog.querySelector('[data-cr-dialog-author]').textContent = button.dataset.crAuthor;
          dialog.showModal();
        }, {signal}));
        this.querySelector('[data-cr-close]').addEventListener('click', () => dialog.close(), {signal});
        dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();}, {signal});
        dialog.addEventListener('close', () => photoTrigger?.focus(), {signal});
        const gallery = this.querySelector('[data-cr-gallery]');
        if (gallery) {
          let drag;
          gallery.addEventListener('pointerdown', event => {this.galleryDragged = false;if(event.pointerType === 'mouse' && event.button === 0) drag = {x:event.clientX,left:gallery.scrollLeft,id:event.pointerId};}, {signal});
          gallery.addEventListener('pointermove', event => {
            if (!drag || Math.abs(event.clientX-drag.x) < 5) return;
            this.galleryDragged = true;gallery.classList.add('is-dragging');gallery.setPointerCapture(drag.id);event.preventDefault();gallery.scrollLeft = drag.left-(event.clientX-drag.x);
          }, {signal});
          const stop = () => {drag = undefined;gallery.classList.remove('is-dragging');};
          gallery.addEventListener('pointerup', stop, {signal});gallery.addEventListener('pointercancel', stop, {signal});gallery.addEventListener('lostpointercapture', stop, {signal});
          gallery.addEventListener('dragstart', event => event.preventDefault(), {signal});
          gallery.addEventListener('keydown', event => {if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();gallery.scrollBy({left:(event.key === 'ArrowLeft'?-1:1)*(gallery.firstElementChild.offsetWidth+8),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}}, {signal});
        }
        this.addEventListener('shopify:block:select', event => {
          const card = cards.find(item => item.dataset.crReview === event.detail.blockId);
          if (card) {filter.value = 'all';search.value='';photos.checked=false;visibleLimit=cards.length;apply();card.scrollIntoView({block:'center',behavior:'smooth'});}
          const image = Array.from(this.querySelectorAll('[data-cr-gallery-block]')).find(item => item.dataset.crGalleryBlock === event.detail.blockId);
          if(image) image.scrollIntoView({block:'center',inline:'center',behavior:'smooth'});
        }, {signal});
        const result = this.querySelector('[data-cr-form-result]');
        if (result) {this.querySelector('.cr-write').open = true;result.scrollIntoView({block:'center'});}
        apply();
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
